import { EntitiesSocketMessageData } from "./entities-socket-message-data"
import { EntitySocketMessageData } from "./entity-socket-message-data"

/**
 * A socket message
 */
class SocketMessage<T extends keyof SocketMessage.Types> {
    /**
     * Constructs a socket message
     * @param type the type
     * @param data the data
     */
    constructor(public type: T, public data: SocketMessage.Types[T]) {}
}
namespace SocketMessage {
    /** All the socket message types */
    export type Types = {
        'new-entity': EntitySocketMessageData<any>,
        'edited-entity': EntitySocketMessageData<any>,
        'deleted-entity': EntitySocketMessageData<any>,
        'entities': EntitiesSocketMessageData<any>,
    }
}
export default SocketMessage